import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'

import { api_gateway } from '../../../conexoes/api'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'

export default function SelectFatConta(props) {
  const [spinAtivo, setSpinAtivo] = useState(false)
  const [lsConta, setLsConta] = useState([])
  const modal = useRef()

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  function handleConta(codigoConta, NomeConta, diaVencimento, diaInicio) {
    props.setCdConta(codigoConta)
    props.setDsConta(NomeConta)
    props.setDiaVencimento(diaVencimento)
    props.setDiaInicio(diaInicio)
    handleCancelar()
  }

  function handleCancelar() {
    props.setRevelarSelectFatConta(false)
  }

  useEffect(() => {
    setSpinAtivo(true)
    async function renderConta() {
      const { data } = await api_gateway.get(
        '/m1/consultar/fat_conta?cd_pav_usuario=' + decryptJWT('codigo')
      )

      if (data.dados.length > 0) {
        let objetoConta = data.dados.map((item, i) => {
          return (
            <li key={'menu-' + item.cd_fat_conta}>
              <div
                className="campo-select-opcao campo-select-opcao-1"
                onClick={() =>
                  handleConta(
                    item.cd_fat_conta,
                    item.ds_conta,
                    item.n0_dia_vencimento,
                    item.n0_dia_inicial_ciclo
                  )
                }
              >
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  {item.ds_conta}
                </span>
              </div>
              {data.dados[i + 1] != undefined && (
                <div className="campo-select-divisor-cor-1 campo-select-divisor" />
              )}
            </li>
          )
        })
        setLsConta(objetoConta)
      } else {
        let objetoConta = () => {
          return (
            <li>
              <div disabled className="campo-select-opcao campo-select-opcao-1">
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  Nenhuma informação encontrada
                </span>
              </div>
            </li>
          )
        }
        setLsConta(objetoConta)
      }
      setSpinAtivo(false)
    }
    renderConta()
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form ref={modal}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <Button
        name="cdTipoPessoa"
        className="campo-texto-cor-3 campo-select"
        onClick={() => props.setRevelarSelectFatConta(false)}
      >
        <div className="fonte-cor-1 label-campo">{props.dsConta}</div>
        <img
          className="campo-select-icone-ativado"
          src={setaDropdown()}
          alt="drop"
        />
      </Button>
      <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
      <div className="campo-texto-cor-3 campo-select-corpo">
        <ul className="campo-select-lista">{lsConta}</ul>
      </div>
    </Form>
  )
}
